// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  MODULES_CLEAR_MODULE_ANSWER,
} from './constants';

export function clearModuleAnswer () {
  return {
    type: MODULES_CLEAR_MODULE_ANSWER,
  };
}

export function reducer (state, action) {
  switch (action.type) {
    case MODULES_CLEAR_MODULE_ANSWER:
      return {
        ...state,
        answer: null,
        clearXpAnswer: null,
        clearXpCompletionInfo: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/clearModuleAnswer.js